export const APP_VERSION = '2.2.0'
export const APPS = 203
